import Axios from 'axios';
import { RadioGroup } from 'devextreme-react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import Cookies from 'js-cookie';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import api from '../../../services/api-configuration';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, Collapse, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Row } from 'reactstrap';
import * as XLSX from 'xlsx';
import { useAuth } from '../../../auth';
import { goRiceUrl } from '../../../constant/siteConstants';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';
import Breadcrumb from '../breadcrumb';
const ExcelUpload = ({ requiredColumnsSase, optionalColumns = [], process_type, ExcelName, Title, depo, exampleData,
    role_name, extraInfo
}) => {
    const { t } = useFormatMessage();
    const [isLoading, setIsLoading] = useState(false);
    // production list (Şase Tanımlama, FABRİKA): the factory is chosen on screen, the cars go to its production zone
    const [creator, setCreator] = useState("GEMİ");
    const [factories, setFactories] = useState([]);
    const [factory, setFactory] = useState("");
    const [voyages, setVoyages] = useState([]);
    const [voyage, setVoyage] = useState("");
    useEffect(() => {
        if (process_type !== "VEHICLE") return;
        api.post("/custody/factorySites", {}).then((r) => setFactories(r.data || [])).catch(() => setFactories([]));
        // vessel list (GEMİ): the arriving voyage is chosen on screen, no "Gemi Adı" column (Sevkiyat İşlemleri > Gemi Seferleri)
        api.post("/custody/importVoyages", {}).then((r) => setVoyages(r.data || [])).catch(() => setVoyages([]));
    }, [process_type]);

    const { hasRole } = useAuth(15);


    const notifySuccess = (message) => toast.success(`${message}`, {
        autoClose: 10000
    });

    const notifyError = (message) => toast.error(`${message}`, {
        autoClose: 10000
    });

    const notifyWarning = (message) => toast.warn(`${message}`, {
        autoClose: 10000
    });

    const [file, setFile] = useState(null);
    const [parsedFile, setParsedFile] = useState({ file: null, headers: [], rowCount: 0 });
    const [columnsValid, setColumnsValid] = useState(false);
    const [uploadStage, setUploadStage] = useState('');
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    const [error, setError] = useState('');
    const fileInputRef = useRef(null);
    const [errorArray, setErrorArray] = useState([]);
    // const [warningArray, setWarningArray] = useState([]);
    const [shipWarningArray, setShipWarningArray] = useState([]);
    const [warningsArray, setWarningsArray] = useState([]);
    const [uploadStats, setUploadStats] = useState(null);
    const [successResults, setSuccessResults] = useState([]);
    const [isCollapseOpen, setIsCollapseOpen] = useState(false);

    const errorGridRef = useRef(null);
    const warningGridRef = useRef(null);
    const warningsGridRef = useRef(null);
    const successGridRef = useRef(null);

    const toggleCollapse = () => {
        setIsCollapseOpen(!isCollapseOpen);
    };

    useEffect(() => {
        if (!isLoading) { setElapsedSeconds(0); return undefined; }
        const started = Date.now();
        const timer = setInterval(() => setElapsedSeconds(Math.floor((Date.now() - started) / 1000)), 1000);
        return () => clearInterval(timer);
    }, [isLoading]);

    const canonicalHeader = (header) => {
        let value = String(header || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('tr-TR')
            .replaceAll('ş', 's').replaceAll('ı', 'i');
        if (value === 'vin') value = 'sase';
        return value;
    };

    const checkHeaders = (headers) => {
        let requiredCols = [...requiredColumnsSase];
        if (process_type === "VEHICLE") requiredCols = requiredCols.filter(col => col !== "warning" && col !== "warning_date");
        const normalizedHeaders = headers.map(canonicalHeader).filter(Boolean);
        const normalizedRequired = requiredCols.map(canonicalHeader);
        const allowedColumns = (process_type === "VEHICLE" ? [...requiredCols, "warning", "warning_date"] : [...requiredCols, ...optionalColumns])
            .map(canonicalHeader);
        const missingColumns = requiredCols.filter((_, index) => !normalizedHeaders.includes(normalizedRequired[index]));
        const extraColumns = headers.filter((header) => canonicalHeader(header) && !allowedColumns.includes(canonicalHeader(header)));
        if (missingColumns.length || extraColumns.length) {
            const missing = missingColumns.map(col => `<span style="color: red;">${col}</span>`).join(", ") || "Yok";
            const extra = extraColumns.map(col => `<span style="color: red;">${col}</span>`).join(", ") || "Yok";
            setError(`Eksik kolonlar: ${missing} <br/> Tanınmayan kolonlar: ${extra}<br/><small>Başlıklar seçilen dosyada hemen kontrol edildi. Büyük/küçük harf, Türkçe I/İ ve baştaki/sondaki boşluklar kabul edilir.</small>`);
            setColumnsValid(false);
            return false;
        }
        setError('');
        setColumnsValid(true);
        return true;
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (event) => {
                try {
                    const data = new Uint8Array(event.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    const allRows = XLSX.utils.sheet_to_json(worksheet);
                    const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false })[0] || [];

                    setFile(selectedFile);
                    setParsedFile({ file: selectedFile, headers, rowCount: allRows.length });
                    checkHeaders(headers);
                } catch (error) {
                    const errorMessage = `
                        <div style="text-align: center; color: red; font-weight: bold;">
                            ⚠️ Excel dosyası okunurken bir hata oluştu!
                        </div>`;
                    setError(errorMessage);
                    notifyError("Excel dosyası okunurken bir hata oluştu!");
                    setFile(null);
                    setParsedFile({ file: null, headers: [], rowCount: 0 });
                    setColumnsValid(false);
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                }
            };
            reader.readAsArrayBuffer(selectedFile);
        }
    };

    const validateFileColumns = async (file) => {
        if (parsedFile.file === file) return checkHeaders(parsedFile.headers);
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
            reader.onload = (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];

                resolve(checkHeaders(headers));
            };
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(file);
        });
    };

    const handleSubmit = async () => {
        setIsLoading(true); // Start loading
        setUploadStage('Dosya doğrulanıyor');
        document.getElementById("submit-button").disabled = true;

        if (depo) {
            if (document.querySelector("#depo-select-box").childNodes[0].childNodes[0].value === "") {
                notifyError(t("Lütfen bir depo seçiniz."));
                document.getElementById("submit-button").disabled = false;
                setIsLoading(false); // Stop loading
                return;
            }
        }

        if (!file) {
            notifyError(t("Lütfen önce bir Excel dosyası yükleyin."));
            document.getElementById("submit-button").disabled = false;
            setIsLoading(false); // Stop loading
            return;
        }

        const isValid = await validateFileColumns(file);
        if (!isValid) {
            document.getElementById("submit-button").disabled = false;
            setIsLoading(false); // Stop loading
            return;
        }

        const formData = new FormData();
        let warehouseCode;

        if (depo) {
            warehouseCode = document.getElementById('depo-select-box')
                .childNodes[0]
                .childNodes[0]
                .value;
            formData.append('warehouse_code', warehouseCode);
        }
        else if (process_type === "VEHICLE") {
            const isMilli = document.getElementById('isMilli')
                .childNodes[0]
                .value === "false";
            warehouseCode = isMilli ? "D000001" : "D000002";
            if (creator === "FABRİKA") {
                if (!factory) {
                    notifyError(t("Lütfen üretim listesinin ait olduğu fabrikayı seçiniz."));
                    setIsLoading(false);
                    document.getElementById("submit-button").disabled = false;
                    return;
                }
                warehouseCode = factory; // the chosen factory's production zone
            }
            if (creator === "GEMİ") {
                if (!voyage) {
                    notifyError(t("Lütfen gemi listesinin ait olduğu seferi seçiniz."));
                    setIsLoading(false);
                    document.getElementById("submit-button").disabled = false;
                    return;
                }
                formData.append('voyage_id', voyage);
            }
            formData.append('warehouse_code', warehouseCode);
        }
        else {
            formData.append('warehouse_code', "");
        }

        formData.append('file', file);
        formData.append('process_type', process_type);
        formData.append('user_id', parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')));

        if (process_type === "VEHICLE") {
            formData.append('creator', document.getElementById("isMilli").childNodes[0].value);
            formData.append('type', document.getElementById('isMilli').childNodes[0].value === "GEMİ" ? "ithal" : "milli");
        }

        let headers = {
            'Content-Type': 'multipart/form-data',
            token: Cookies.get('token')
        };
        let BASE_API = process_type === "PDI_EXIT_CANCEL" ? `/api/updatePdiOrder` : `/api/vehicle/add`
        try {
            setUploadStage(`${parsedFile.rowCount || '?'} satır sunucuya gönderiliyor`);
            const response = await Axios.post(`${goRiceUrl}${BASE_API}`, formData, { headers, timeout: 120000 });
            setUploadStage('Sonuçlar hazırlanıyor');

            if (response.data.success) {
                let errorArray = [];
                let warningsArray = [];
                let warnings = []
                let createdCount = response.data.stats?.created || 0;
                let updatedCount = response.data.stats?.updated || 0;
                let successCount = createdCount + updatedCount;
                let failedCount = response.data.stats?.failed || 0;

                // Process results and convert warning strings to array
                response.data.results.forEach((result) => {
                    if (result.error) {
                        errorArray.push({
                            chassis_no: result.chassis_no,
                            message: t(result.error) || t("Bilinmeyen hata")
                        });
                    }
                    // else if (result.warning) {
                    //     // Handle warning string by creating a warnings array entry
                    //     warningsArray.push({
                    //         chassis_no: result.chassis_no,
                    //         message: result.warning
                    //     });
                    // }
                    if (result.warnings) {
                        warningsArray.push({
                            chassis_no: result.chassis_no,
                            message: result.warnings?.join(" 🔷 ")?.replaceAll("not found for brand", "seçili marka için bulunamadı: ").replaceAll("Brand", "Marka").replaceAll("not found in system", " sistemde tanımlı değil").replaceAll("color", "Renk")
                        })
                    } if (result.warning) {
                        if (result.warning.info && result.warning.date) return
                        warningsArray.push({
                            chassis_no: result.chassis_no,
                            message: result.warning
                        });
                    }
                });

                setErrorArray(errorArray);
                setWarningsArray(warningsArray);
                setUploadStats(response.data.stats);
                setSuccessResults((response.data.results || []).filter(r => r.success && (r.action === "created" || r.action === "updated")));

                let message = `${createdCount} ${t("veri eklendi")}, ${updatedCount} ${t("veri güncellendi")}`;
                if (failedCount > 0) {
                    message += `, ${failedCount} ${t("adet hatalı")}`;
                }
                if (warningsArray.length > 0) {
                    message += `, ${warningsArray.length} ${t("adet uyarılı")}`;
                }
                message += ` ${t("kayıt")}`;

                if (failedCount === 0 && warningsArray.length === 0) {
                    notifySuccess(message);
                } else if (failedCount > 0) {
                    notifyError(message);
                } else if (warningsArray.length > 0) {
                    notifyWarning(message);
                }
            } else {
                notifyError(t("İşlem başarısız oldu."));
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error?.replace("file processing error: failed to transform data:", "") || t("Dosya yüklenirken bir servis hatası oluştu.");
            console.error('Error uploading file:', error);
            notifyError(t("Dosya yüklenirken bir servis hatası oluştu.") + errorMessage, {
                autoClose: 20000
            });
            setErrorArray([{
                chassis_no: "GENEL HATA",
                message: errorMessage || t("Dosya yüklenirken bir servis hatası oluştu.")
            }]);
        } finally {
            setIsLoading(false); // Stop loading regardless of success or failure
            setUploadStage('');
            document.getElementById("submit-button").disabled = false;
        }

        document.getElementById("submit-button").disabled = false;
    };




    const downloadWarningExcel = () => {
        if ((process_type === "BLOCKING_SHIPPING" || process_type === "SHIP_UNLOAD") && file) {
            const reader = new FileReader();

            reader.onload = (event) => {
                try {
                    const data = new Uint8Array(event.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

                    // Get chassis numbers with warnings based on process type
                    const warningChassisNumbers = process_type === "BLOCKING_SHIPPING"
                        ? warningsArray.map(w => w.chassis_no)
                        : shipWarningArray.map(w => w.chassis_no);

                    // Filter rows with warnings
                    const filteredData = jsonData.filter(row =>
                        warningChassisNumbers.includes(row.sase)
                    );

                    // Create new worksheet with filtered data
                    const newWorksheet = XLSX.utils.json_to_sheet(filteredData);
                    const newWorkbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, 'Uyarılı Şaseler');

                    // Set column widths
                    const maxWidth = 20;
                    const columnWidths = Object.keys(filteredData[0] || {}).map(() => ({ wch: maxWidth }));
                    newWorksheet['!cols'] = columnWidths;

                    // Download file
                    XLSX.writeFile(
                        newWorkbook,
                        `Uyarılı_Şaseler_${moment().format('YYYY-MM-DD')}.xlsx`
                    );

                } catch (error) {
                    console.error('Excel oluşturma hatası:', error);
                    notifyError(t("Excel dosyası oluşturulurken bir hata oluştu."));
                }
            };

            reader.readAsArrayBuffer(file);
        }
    };
    const clearFile = () => {
        setFile(null);
        setParsedFile({ file: null, headers: [], rowCount: 0 });
        setColumnsValid(false);
        setError('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        const fileInput = document.getElementById('excelUpload');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const processWarnings = (warningsArray) => {
        const groupedWarnings = warningsArray.reduce((acc, curr) => {
            if (!acc[curr.chassis_no]) {
                acc[curr.chassis_no] = [];
            }
            acc[curr.chassis_no].push(curr.message);
            return acc;
        }, {});

        return Object.entries(groupedWarnings).map(([chassis_no, messages]) => ({
            chassis_no,
            message: messages.join('<br/>')
        }));
    };

    const WarningsCell = ({ value }) => {
        return <div dangerouslySetInnerHTML={{ __html: t(value) }} />;
    };

    const renderResultGrid = (data, ref, title, color) => {
        console.log(data)
        if (!data || data?.length === 0) return null;
        if (data?.[0]?.message?.info) return null;
        if (data?.length > 0) {
            return (
                <div className="space-y-4 mt-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="font-bold" style={{ color }}>{t(title)}:</span>
                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center"
                            }}
                        >
                            {process_type === "BLOCKING_SHIPPING" && title === "Şase Uyarı Mesajları" && (
                                <>
                                    <Link
                                        target="_blank"
                                        style={{
                                            height: "38px",
                                            margin: "0px"
                                        }}
                                        to="/tanimlamalar/sevkiyat-yerleri"
                                        className="btn btn-info mr-1"
                                    >
                                        {t("Sevkiyat Yeri Tanımlama")}
                                    </Link>
                                    <Button
                                        style={{ height: "38px" }}
                                        className="btn btn-warning mr-2"
                                        onClick={downloadWarningExcel}
                                    >
                                        {t("Uyarılı Şaseleri İndir")}
                                    </Button>
                                </>
                            )}
                            <Button
                                className="btn btn-success"
                                style={{ height: "38px" }}
                                onClick={(e) => {
                                    ButtonOnExporting(
                                        e,
                                        ref,
                                        `${ExcelName} - ${title} - ${moment(new Date()).format("DD/MM/YYYY")}`,
                                        "Sayfa-1"
                                    );
                                }}
                            >
                                <i className="fa fa-file-excel-o"></i>
                            </Button>
                        </div>
                    </div>
                    <DataGrid
                        ref={ref}
                        dataSource={data}
                        showColumnHeaders={false}
                        filterRow={{ visible: true }}
                        showColumnLines={true}
                        showRowLines={true}
                        showBorders={true}
                    >
                        <Column
                            dataField="chassis_no"
                            alignment="center"
                            selectedFilterOperation="contains"
                            width={200}
                        />
                        <Column
                            dataField="message"
                            selectedFilterOperation="contains"
                            // cellRender={({ value }) => <div dangerouslySetInnerHTML={{ __html: value }} />}
                            calculateDisplayValue={(e) => {

                                let message = e.message ? e.message : e.error ? e.error : e.warning ? e.warning : ""

                                console.log(message)
                                if (message.includes("invalid client code")) {
                                    const codeMatch = message.match(/\((\d+)\)/); // Parantez içindeki kodu yakalar
                                    const nameMatch = message.match(/name \((\w+)\)/);

                                    const code = codeMatch ? codeMatch[1] : "";
                                    const name = nameMatch ? nameMatch[1] : "";
                                    // return t("error.invalid_client_code") + ` (${code}) - ${name}`;
                                    return message || ""
                                }
                                message = message.split(":")

                                message = message.map((m, index) => {
                                    if (index === 0) {
                                        return t(m.trim())
                                    }
                                    return t(m.trim())
                                })
                                return message.join(": ")
                            }}
                        />
                    </DataGrid>
                </div>
            );
        }
    };
    return (
        <>
            <Breadcrumb current={t(Title)} depo={depo} />
            <Card className="mt-1">
                <CardBody>
                    <Row>
                        <Col md="6" className='d-flex align-items-center' style={{ gap: "15px" }}>
                            {process_type === "VEHICLE" &&
                                <RadioGroup
                                    id='isMilli'
                                    items={[{ text: "GEMİ", value: false }, { text: "FABRİKA", value: true },
                                    { text: "BAYİ", value: true },
                                    { text: "DEPO", value: true }
                                    ]}
                                    defaultValue={"GEMİ"}
                                    layout="horizontal"
                                    displayExpr={"text"}
                                    valueExpr={"text"}
                                    itemRender={({ text }) => t(text)}
                                    onValueChanged={(e) => setCreator(e.value)}
                                />
                            }
                            {process_type === "VEHICLE" && creator === "GEMİ" && (
                                <Input type="select" id="voyage-select" style={{ maxWidth: 420 }} value={voyage}
                                    onChange={(e) => setVoyage(e.target.value)}>
                                    <option value="">{t("Sefer seçiniz")}{voyages.length === 0 ? ` (${t("açık ithalat seferi yok")})` : ""}</option>
                                    {voyages.map((v) => (
                                        <option key={v.id} value={v.id}>
                                            {v.voyage_no} · {v.vessel_name} ({v.operator_name}) · {v.operator_voyage_no} → {v.discharge_location}
                                        </option>
                                    ))}
                                </Input>
                            )}
                            {process_type === "VEHICLE" && creator === "FABRİKA" && (
                                <Input type="select" id="factory-select" style={{ maxWidth: 280 }} value={factory}
                                    onChange={(e) => setFactory(e.target.value)}>
                                    <option value="">{t("Fabrika seçiniz")}</option>
                                    {factories.map((f) => (
                                        <option key={f.code} value={f.code} disabled={!f.has_production}>
                                            {f.name}{f.has_production ? "" : ` (${t("üretim bölgesi tanımlı değil")})`}
                                        </option>
                                    ))}
                                </Input>
                            )}
                        </Col>
                    </Row>

                    <Row className='mb-4'>
                        <Col md="6">
                        </Col>
                        <Col md="6" style={{ textAlign: "right" }}>
                            <b>
                                {t("Yüklemek İstediğiniz Excel Dosyasını seçiniz. Excel Şablonunu")}
                                <span style={{
                                    color: "blue",
                                    cursor: "pointer"
                                }} onClick={() => downloadSampleExcel(
                                    requiredColumnsSase,
                                    process_type,
                                    Title,
                                    optionalColumns
                                )}> {t("buradan")} </span>
                                {t("indirebilirsiniz")}.
                            </b>
                        </Col>
                    </Row>

                    <FormGroup style={{ display: "flex" }}>
                        <Label for="excelUpload" className="font-weight-bold">
                            {t("Excel Dosyası Yükle")}
                        </Label>
                        <InputGroup>
                            <Input
                                id="excelUpload"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                                style={{ display: 'none', height: "100%" }}
                                ref={fileInputRef}
                            />
                            <Input
                                type="text"
                                placeholder="Choose file..."
                                value={file ? file.name : ''}
                                readOnly
                                style={{ height: "100%" }}
                            />
                            <InputGroupAddon addonType="append" onClick={() => clearFile()}>
                                <InputGroupText>
                                    <Label for="excelUpload" style={{ cursor: 'pointer', marginBottom: 0 }}>
                                        {t("Seç")}
                                    </Label>
                                </InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </FormGroup>

                    <br />
                    {error && (
                        <Row>
                            <Col md="12">
                                <p style={{ fontWeight: "bold", fontSize: "15px", color: "black" }}
                                    dangerouslySetInnerHTML={{ __html: error }} />
                            </Col>
                        </Row>
                    )}
                    {file && columnsValid && (
                        <div className="text-success mb-2">
                            ✓ Kolonlar uygun · {parsedFile.rowCount} veri satırı hazır
                        </div>
                    )}
                    <br />

                    <Row>
                        <Col md="12" style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <Button
                                color='danger'
                                disabled={file === null || isLoading}
                                onClick={clearFile}
                            >
                                {t("Temizle")}
                            </Button>
                            {isLoading && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    color: '#007bff'
                                }}>
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span style={{ fontWeight: 'bold' }}>{uploadStage || t("Yükleniyor. Lütfen sayfan çıkmadan bekleyiniz...")}{elapsedSeconds > 0 ? ` · ${elapsedSeconds} sn` : ''}</span>
                                </div>
                            )}
                            {
                                true &&
                                <Button
                                    color="primary"
                                    id='submit-button'
                                    disabled={file === null || isLoading || !columnsValid}
                                    onClick={handleSubmit}
                                    style={{ width: "max-content" }}
                                >
                                    {t("Kaydet")}
                                </Button>}
                        </Col>
                    </Row>

                    <hr />
                    <Row>
                        <Col md="12" className='mb-2'>
                            <span style={{
                                color: "blue",
                                fontWeight: "bold"
                            }}>
                                {exampleData ?
                                    t("Excel Dosyasında bulunması gereken kolonlar ve örnek veri")
                                    :
                                    t("Excel Dosyasında bulunması gereken kolonlar")}:
                            </span>
                        </Col>
                        <Col md="12">
                            <table className="table table-bordered">
                                <thead>
                                    <tr style={{
                                        backgroundColor: "#e2e2e2"
                                    }}>
                                        {requiredColumnsSase.map((column, index) => (
                                            <th
                                                style={{ border: "1px solid rgb(208 208 208)" }}
                                                key={index}
                                            >
                                                {column}
                                                {column === "sase" &&
                                                    <span style={{
                                                        color: "red",
                                                        fontWeight: "900",
                                                        fontSize: "17px"
                                                    }}>*</span>
                                                }
                                            </th>
                                        ))}
                                        {optionalColumns.map((column) => (
                                            <th style={{ border: "1px solid rgb(208 208 208)" }} key={column}>
                                                {column} <span style={{ fontWeight: "normal", fontStyle: "italic" }}>({t("isteğe bağlı")})</span>
                                            </th>
                                        ))}
                                    </tr>
                                    {
                                        exampleData &&
                                        exampleData.map((data, index) => (
                                            <tr key={index}>
                                                {[...requiredColumnsSase, ...optionalColumns].map((column, index) => (
                                                    <td style={{
                                                        padding: "5px",
                                                    }}
                                                        key={index}>{data[column]}</td>
                                                ))}
                                            </tr>
                                        ))
                                    }
                                    {
                                        exampleData === undefined &&
                                        <tr>
                                            {
                                                requiredColumnsSase.map((column, index) => (
                                                    <td key={index}>
                                                        <i>{column === "GEMİ Varış Tarihi" ? "Date" : "Text"}</i>
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                        // requiredColumnsSase.map((column, index) => (
                                        //     <td key={index}>
                                        //         <i>{column === "GEMİ Varış Tarihi" ? "Date" : "Text"}</i>
                                        //     </td>
                                        // ))}
                                    }
                                </thead>
                            </table>
                        </Col>
                    </Row>
                    {extraInfo}

                    <hr />

                    {/* Error Grid */}
                    {renderResultGrid(errorArray, errorGridRef, "Hatalı Şase Listesi", "red")}

                    {/* Warning Grid */}
                    {/* {process_type === "SHIP_UNLOAD" &&
                        renderResultGrid(warningsArray, warningGridRef, "Uyarılı Şase Listesi", "orange")} */}

                    {/* Warnings Grid */}
                    {renderResultGrid(warningsArray, warningsGridRef, "Şase Uyarı Mesajları", "#DAA520")}

                    {process_type === "VEHICLE" && uploadStats && (
                        <div className="mt-4">
                            <div
                                style={{
                                    fontWeight: "bold",
                                    marginBottom: "8px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    padding: "8px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "4px",
                                    border: "1px solid #dee2e6"
                                }}
                                onClick={toggleCollapse}
                            >
                                <div>
                                    {`${uploadStats.created || 0} ${t("veri eklendi")}, ${uploadStats.updated || 0} ${t("veri güncellendi")}: ${t("Şase listesi")}`}
                                </div>
                                <div>
                                    {isCollapseOpen ? "▼" : "▶"}
                                </div>
                            </div>

                            <Collapse isOpen={isCollapseOpen}>
                                <div className="mt-3">
                                    <div className="mt-3 d-flex justify-content-end" >
                                        <Button
                                            className="btn btn-success"
                                            onClick={(e) => {
                                                ButtonOnExporting(e, successGridRef, `${ExcelName} - ${t("Şase listesi")} - ${moment(new Date()).format("DD/MM/YYYY")}`, "Sayfa-1")
                                            }}
                                        >
                                            <i className="fa fa-file-excel-o"></i>
                                        </Button>
                                    </div>
                                    <DataGrid
                                        ref={successGridRef}
                                        dataSource={successResults}
                                        showBorders={true}

                                        allowColumnReordering={true}
                                        allowColumnResizing={true}
                                        columnAutoWidth={true}
                                        showColumnLines={true}
                                        showRowLines={true}
                                        showColumnHeaders={false}
                                        filterRow={{ visible: true }}
                                        onExporting={ButtonOnExporting}
                                    >
                                        <Column dataField="chassis_no" caption={t("Şase No")} />
                                        <Column dataField="action" caption={t("Durum")} calculateDisplayValue={(e) => {
                                            return t(e.action)
                                        }} />
                                    </DataGrid>
                                </div>
                            </Collapse>


                        </div>
                    )}

                </CardBody>
            </Card>
        </>
    );
};

export default ExcelUpload;

// optional columns go into the template after the required ones (the upload accepts the file with or without them)
export const downloadSampleExcel = (requiredColumnsSase, process_type, Title, optionalColumns = []) => {
    let templateColumns = [...requiredColumnsSase, ...optionalColumns];
    if (process_type === "VEHICLE") {
        templateColumns = requiredColumnsSase;
    }

    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, [templateColumns]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sayfa1');
    XLSX.writeFile(workbook, `${Title}.xlsx`);
};
